var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.params ? `${_vm.to}?${_vm.params}` : _vm.to},on:{"click":_vm.linkTo}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }